<template >
  <section>
     <!-- Content Header (Page header) -->
     <section class="content-header">
        <h1>
           MARCACIONES
           <small>Percy</small>
        </h1>
        <ol class="breadcrumb">
           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
           <li class="active">Marcaciones</li>
        </ol>
     </section>
     <!-- Main content -->
     <section class="content">
        <div class="row">
        <!-- left column -->
          <div class="col-md-12">
             <!-- general form elements -->
             <div class="box box-primary">
                <div class="box-header with-border">
                   <h3 class="box-title"></h3>
                </div>
                <!-- /.box-header -->
                <!-- form start -->
                <form class="" @submit.prevent="filterDate()">
                   <div class="row">
                      <div class="col-md-12">


                        <div class="col-md-3">
                           <div class="form-group">
                              <label>Fecha de Inicio</label>
                              <input type="text" id="filterFI" class="form-control"  v-model="filterFI">
                           </div>
                        </div>
                        <div class="col-md-3">
                           <div class="form-group">
                              <label>Fecha de Termino</label>
                              <input type="text" id="filterFF" class="form-control"  v-model="filterFF">
                           </div>
                        </div>
                        <div class="col-md-6">
                           <div class="form-group">
                              <p>El periodo deber ser menos a 6 meses.</p>
                              <button type="submit" class="btn btn-info btn-fill pull-right"
                                style="float:left !important;"
                                > <i class="fa fa-search"></i> Buscar</button>
                              <div class="clearfix"></div>
                           </div>
                        </div>

                      </div>

                   </div>
                </form>




             </div>
             <!-- /.box -->
          </div>
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="content table-responsive table-full-width" >
               <table class="table table-condensed">
                  <thead>
                     <tr class="active">
                        <th>FECHA</th>
                        <th>INGRESO</th>
                        <th>INI.REF.</th>
                        <th>FIN.REF.</th>
                        <th>SALIDA</th>
                        <th>TARDANZA</th>
                        <th>EXC.REF.</th>
                        <th>RET.ANT.</th>
                        <th>SAL.NAUT.</th>
                        <th>PER.ADI.</th>
                        <th>OBSERVACIÓN</th>
                        <th>DET.SAL.NO AUTORIZADAS</th>
                        <th>DETALLE</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="marca in marcaciones">
                        <td data-title="CÓDIGO">{{marca.fecha }}</td>
                        <td data-title="NÚMERO"> {{marca.dateBegin}}</td>
                        <td data-title="DEMANDANTE"> {{ marca.datebeginlounch }} </td>
                        <td data-title="DEMANDADO">{{ marca.dateendlounch }}</td>
                        <td data-title="COLEGIADO"> {{ marca.dateend }} </td>
                        <td data-title="INGRESO"> {{marca.latelounch}}</td>
                        <td data-title="INGRESO"> {{ marca.previusHour}} </td>
                        <td data-title="COLEGIADO"> {{marca.hoursnotautorized}} </td>
                        <td data-title="INGRESO">{{ marca.restextrahours}}</td>
                        <td data-title="INGRESO">{{marca.comments}}</td>
                        <td data-title="INGRESO">{{marca.detail}}</td>
                        <td data-title="INGRESO">{{marca.detail}}</td>
                        <td data-title="VER">


                          <span rel="tooltip"
                            @click="selectMarcacion(marca)"
                            title="Ver Expediente" data-state="primary" data-placement="right" class="fa fa-file-pdf-o"></span>
                        </td>
                     </tr>
                  </tbody>
               </table>
            </div>



            <div class="col-md-12">
              <br>
              <button class="btn btn-info"><i class="fa fa-download"></i> Descargar Archivo</button>
              <br>
              <br>

              <div class="col-md-12">

                <div class="col-md-6">
                  <b>Leyenda</b>
                  <ul>
                    <li>INI.REF. = Salida por Refigerio.</li>
                    <li>FIN.REF. = Retorno de Refigerio.</li>
                    <li>EXC.REF. = Exceso de tiempo en Refrigerio (lo permitido es una hora máximo).</li>
                    <li>RET.ANT. = Retiro antes de horario de salida.</li>
                  </ul>
                </div>

                <div class="col-md-6">
                   <ul>
                    <li>SAL.NAUT. = Periodo acumulado por salidas no autorizadas (salidas no sustentadas con papeletas).</li>
                    <li>PER.ADL. = Permanencia adicional.</li>
                    <li>DET.SAL. NO AUTOIRZADAS = Detalle en caso tenga salidas no autorizadas.</li>
                  </ul>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
     </section>
  </section>



</template>
<script>


  import { mapMutations } from 'vuex'

  import config from '../../config';

  export default {
    name : 'Marcaciones',
    data(){
      return {
        marcaciones : [],
        filterFF : null,
        filterFI : null,
      }
    },
    mounted(){
          console.log('Iniciando');
          // $(".table").DataTable();

          console.log('AI')
          let fechaInicial ='2012-19-03';// moment().format('YYYY-DD-MM');
          let fechaFinal = moment().add(1, 'days').format('YYYY-DD-MM');

          axioss.get(config.serverURI + 'aplicaciones/consultapapeleta/100255/'+ fechaInicial +'/' + fechaFinal)
            .then((response)=>{
              let data = response.data;
                this.marcaciones = data;
              console.log('Responde',response);



            })

          //axioss.get(config.serverURI+'aplicaciones/checksum')
            //.then((data)=>{
              //console.log('Mi datos devuelto es ', data );
              //this.marcaciones = data.data;
            //})



        		$('#filterFI').datetimepicker({format:'Y-d-m'});
            $('#filterFF').datetimepicker({format:'Y-d-m'});

    },

    methods : {
        ...mapMutations([
          'GET_MARCACIONES'
        ]),

        filterDate(){
          console.log('Filtramos la fechas  con ', this.filterFI, this.filterFF );

          this.filterFI = $('#filterFI').val();
          this.filterFF = $('#filterFF').val();


          swal({
            title: "Cargando...",
            text: " ",
            icon: "info",
            buttons: false,
            dangerMode: true,
          })



          axioss.get(config.serverURI + 'aplicaciones/consultapapeleta/100255/'+this.filterFI + '/' + this.filterFF)
            .then((response)=>{

              swal.close();

              console.log('Finalizando' , response);

              let data = response.data;


                this.marcaciones = data;


            });

        },
        selectMarcacion(marca){



          console.log('dispatch',marca);
          this.$store.dispatch('selectMarcacion',marca);
          this.$router.push('/marcacion')

        }

    },


  }
</script>



// WEBPACK FOOTER //
// src/components/views/Marcaciones.vue